import BestPlansService from '../../services/BestPlansService';
import PlansActionType from '../../common/PlansActionType';
import HomeAction from '../../redux/actions/HomeAction';
import CheckoutActionType from '../../common/CheckoutActionType';
import DashboardConstants from '../../components/myaccount/DashboardConstants';
import LogoutAction from './LogoutAction';

const isPlanChoiceRequired = plans => !plans.isCurrentPlanAvailable;

const storePlanData = (tui, isChange, adressId) => async (dispatch) => {
  if (tui.length === 0) {
    dispatch({ type: PlansActionType.STORE_PLAN_DATA });
    return;
  }
  const response = await BestPlansService.fetchBestPlans(tui, isChange, adressId);
  if (response.status === 200) {
    dispatch({ type: PlansActionType.STORE_PLAN_DATA, ...response.planData });
    if (isPlanChoiceRequired(response.planData)) {
      dispatch(
        {
          type: CheckoutActionType.SET_SPEED_CHANGE_OPTION,
          value: DashboardConstants.CHANGE_OR_EXISTING_OPTIONS[1].id
        }
      );
    }
  } else if (response.status === 401) {
    LogoutAction.logout(dispatch, response.message);
  } else {
    dispatch({ type: PlansActionType.STORE_PLAN_DATA });
    dispatch(HomeAction.storeError(response));
  }
};

const setSelectedPlan = planId => ({ type: PlansActionType.SET_SELECTED_PLAN, id: planId });
const setMobileDiscount = withMobileDiscountInfo => ({
  type: PlansActionType.SET_MOBILE_DISCOUNT, withMobileDiscountInfo
});
const setContractSelected = isContractSelected => ({
  type: PlansActionType.SET_CONTRACT_SELECTED,
  isContractSelected
});

const setByoModemSelected = isByoModemSelected => ({
  type: PlansActionType.SET_BYOMODEM_SELECTED,
  isByoModemSelected
});

const setImportantInfoTickboxSelected = isImportantInfoTickbox => ({
  type: PlansActionType.SET_IMPORTANTINFO_TICKBOX_SELECTED,
  isImportantInfoTickbox
});

const switchToOpenTerm = () => ({ type: PlansActionType.SWITCH_TO_OPEN_TERM });

// const resetPlans = () => ({ type: PlansActionType.RESET_ALL });

export default {
  storePlanData,
  setSelectedPlan,
  setContractSelected,
  switchToOpenTerm,
  setMobileDiscount,
  setByoModemSelected,
  setImportantInfoTickboxSelected
};



/** WEBPACK FOOTER **
 ** ./src/redux/actions/PlansAction.js
 **/